module.exports = __webpack_public_path__ + "media/images/social/telegram-56cf800554fbc0544c68e3a575dccc3a.svg";